import React, { useEffect, useState } from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NewsLetter from './Components/NewsLetter';
import Cotizar from './Components/Cotiza';
import { BASE_URL, API_BASE_URL } from './Constants';
import { Link } from 'react-router-dom';


const Solutions: React.FC = () => {

  const [productos, setProductos] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const settings_home = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    arrows: false,
    draggable: false,
    swipe: false
  };

  useEffect(() => {
    fetchProductos();
  }, []);

  const fetchProductos = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}soluciones/all`);
      if (response.ok) {
        const data = await response.json();
        setProductos(data);
      } else {
        console.error('Error al cargar las soluciones');
      }
    } catch (error) {
      console.error('Error al cargar los soluciones:', error);
    } finally {
      setLoading(false);
    }
  };

  const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < breakpoint);
      };

      window.addEventListener('resize', handleResize);

      // Limpia el evento cuando el componente se desmonta
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [breakpoint]);

    return isMobile;
  };
  const formatText = (text: string) => {
    const regex = /\*([^*]+)\*/g;
    const parts = text.split(regex);
    return parts.map((part, index) =>
      index % 2 === 1 ? <strong key={index}>{part}</strong> : part
    );
  };
  const isMobile = useIsMobile();

  return (
    <>

      <div className="page-wrapper">
        <Header />

        <section className="main-slider clearfix home">
          <Slider {...settings_home}>
            <div className="item swiper-slide">
              <div className="image-layer slider1Soluciones" >

              </div>

              <div className="container">
                <div className="row">
                  <div className="col-xl-12 col-lg-12">
                    <div className="main-slider__content">
                      <h3 className="main-slider__title text-center">
                        <span style={{ fontWeight: '600' }}>Especialistas en soluciones, somos tu mejor aliado empresarial
                        </span>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </section>


        {/* Nueva sección de Nuestras Soluciones */}
        <section className="project-two" style={{ marginBottom: '0px', paddingTop: '0px', paddingBottom: '40px' }}>
          <div className="project-two__container">
            <div className="titulo-fondoNS">
              <h2 className={isMobile ? 'section-title__titleNS2Mobile' : 'section-title__titleNS2Desktop'}>NUESTRAS SOLUCIONES</h2>
            </div>

            <div className='Inf-Nuestras-soluciones' style={{ display: 'flex', flexDirection: 'column', gap: '60px', maxWidth: '1200px', margin: '0 auto' }}>
              {/* Ámbito Civil */}
              <div className={isMobile ? 'Inf-Nuestras-solucionesMobile2' : 'Inf-Nuestras-solucionesDesktop2'}>
                {/* Lista de características a la izquierda */}
                <div style={{ flex: '1', paddingRight: '20px' }}>
                  <ul className={isMobile ? 'text-Nuestras-solucionesMobile' : 'text-Nuestras-solucionesDesktop'} >
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Elaboración de expedientes técnicos.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Ejecución de obras públicas y privadas.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Movimiento de tierra.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Alquiler de maquinaria.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Diseño y ejecución de trabajos civiles.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Diseño y fabricacion de zonas estancas, muros de
                      contención, anillos de cimentación para tanques en general.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Diseños y ejecución de obras pluviales.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Saneamiento.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Pavimentación.
                    </li>

                  </ul>
                </div>

                {/* Imagen con título en footer a la derecha */}
                <div style={{
                  flex: isMobile ? '1' : '0 0 350px',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  <div style={{ height: '450px', position: 'relative' }}>
                    <img
                      src="/assets/images/resources/Ámbito-Civil.png"
                      alt="Ámbito Civil"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                  <div style={{
                    padding: '20px',
                    textAlign: 'center',
                    backgroundColor: '#023352',
                    color: 'white'
                  }}>
                    <h3 className={isMobile ? 'text-Nuestras-solucionesMobile' : 'text-Nuestras-solucionesDesktop'} style={{
                      fontSize: '20px',
                      fontWeight: '600',
                      margin: '0',
                      fontFamily: 'Axiforma-Regular, sans-serif',
                      color: 'white'
                    }}>
                      Ámbito Civil
                    </h3>
                  </div>
                </div>
              </div>
              {/* Servicios Generales */}


              <div className={isMobile ? 'Inf-Nuestras-solucionesMobile2' : 'Inf-Nuestras-solucionesDesktop2'} style={{
                position: 'relative',
                width: '100vw',
                backgroundColor: '#F5F5F5',
                marginLeft: 'calc(50% - 50vw)',

              }}>
                <div className={isMobile ? 'Inf-Nuestras-solucionesMobile2' : 'Inf-Nuestras-solucionesDesktop2'}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '40px',
                    padding: '40px',
                    maxWidth: '1200px',
                    margin: '0 auto',
                  }}>


                  {/* Lista de características a la izquierda */}
                  <div style={{ flex: '1', paddingRight: '20px' }}>
                    <ul className={isMobile ? 'text-Nuestras-solucionesMobile' : 'text-Nuestras-solucionesDesktop'} >
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Elaboración de expedientes técnicos.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Fabriación y montaje de estructuras metálicas.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Fabriación y montaje de tuberías y equipos.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Fabriación y montaje de tanques de almacenamiento de combustible.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Montaje electromecánico.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Mantenimiento mecánico y paradas de planta.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Mantenimiento y limpieza de tanque de almacenamiento.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Mantenimiento de componentes mecánicos.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Preservación y conservación de equipos mecánicos y electromecánicos.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Flushing de líneas.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Arenado y pintado industrial.
                      </li>
                      <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                        Aislamiento térmico.
                      </li>
                    </ul>
                  </div>

                  {/* Imagen con título en footer a la derecha */}
                  <div style={{
                    flex: isMobile ? '1' : '0 0 350px',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    position: 'relative'
                  }}>
                    <div style={{ height: '450px', position: 'relative' }}>
                      <img
                        src="/assets/images/resources/Ámbito-Metalmecánico.png"
                        alt="Ámbito Metalmecánico"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    </div>
                    <div style={{
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#023352',
                      color: 'white'
                    }}>
                      <h3 className={isMobile ? 'text-Nuestras-solucionesMobile' : 'text-Nuestras-solucionesDesktop'} style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        margin: '0',
                        fontFamily: 'Axiforma-Regular, sans-serif',
                        color: 'white'
                      }}>
                        Ámbito Metalmecánico
                      </h3>
                    </div>
                  </div>
                </div>
              </div>



              {/* Servicios Generales */}
              <div className={isMobile ? 'Inf-Nuestras-solucionesMobile2' : 'Inf-Nuestras-solucionesDesktop2'}>
                {/* Lista de características a la izquierda */}
                <div style={{ flex: '1', paddingRight: '20px' }}>
                  <ul className={isMobile ? 'text-Nuestras-solucionesMobile' : 'text-Nuestras-solucionesDesktop'}>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Venta de productos químicos para la industria petrolera: Servicios de cementación y estimulación.
                    </li>
                  </ul>
                </div>

                {/* Imagen con título en footer a la derecha */}
                <div style={{
                  flex: isMobile ? '1' : '0 0 350px',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  <div style={{ height: '450px', position: 'relative' }}>
                    <img
                      src="/assets/images/resources/Ámbito-PQ.png"
                      alt="Servicios Generales"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                  <div style={{
                    padding: '20px',
                    textAlign: 'center',
                    backgroundColor: '#023352',
                    color: 'white'
                  }}>
                    <h3 style={{
                      fontSize: '20px',
                      fontWeight: '600',
                      margin: '0',
                      fontFamily: 'Axiforma-Regular, sans-serif',
                      color: 'white'
                    }}>
                      Ámbito PQ
                    </h3>
                  </div>
                </div>

              </div>

              {/* Servicios Generales */}
              <div className={isMobile ? 'Inf-Nuestras-solucionesMobile2' : 'Inf-Nuestras-solucionesDesktop2'} style={{
                position: 'relative',
                width: '100vw',
                backgroundColor: '#F5F5F5',
                marginLeft: 'calc(50% - 50vw)',
              }}>
                <div className={isMobile ? 'Inf-Nuestras-solucionesMobile2' : 'Inf-Nuestras-solucionesDesktop2'}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '40px',
                    padding: '40px',
                    maxWidth: '1200px',
                    margin: '0 auto',
                  }}>
                  {/* Lista de características a la izquierda */}
                  <div style={{ flex: 1, paddingRight: '20px' }}>
                    <ul className={isMobile ? 'text-Nuestras-solucionesMobile' : 'text-Nuestras-solucionesDesktop'}>
                      <li style={{ marginBottom: 0, position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: 0, color: '#000', fontWeight: 'bold' }}>•</span>
                        Venta de productos químicos.
                      </li>
                      <li style={{ marginBottom: 0, position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: 0, color: '#000', fontWeight: 'bold' }}>•</span>
                        Servicio integrados de perforación y completación de pozos de petróleo y gas.
                      </li>
                      <li style={{ marginBottom: 0, position: 'relative', paddingLeft: '20px' }}>
                        <span style={{ position: 'absolute', left: 0, color: '#000', fontWeight: 'bold' }}>•</span>
                        Suministro, operación y mantenimientos de equipos de bombos de alta presión y estimulación de pozos petroleros.
                      </li>
                    </ul>
                  </div>

                  {/* Imagen con título en footer a la derecha */}
                  <div
                    style={{
                      flex: isMobile ? '1' : '0 0 350px',
                      borderRadius: '15px',
                      overflow: 'hidden',
                      position: 'relative',
                    }}
                  >
                    <div style={{ height: '450px', position: 'relative' }}>
                      <img
                        src="/assets/images/resources/Ámbito-Petrolero.png"
                        alt="Servicios Generales"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </div>
                    <div
                      style={{
                        padding: '20px',
                        textAlign: 'center',
                        backgroundColor: '#023352',
                        color: 'white',
                      }}
                    >
                      <h3
                        style={{
                          fontSize: '20px',
                          fontWeight: 600,
                          margin: 0,
                          fontFamily: 'Axiforma-Regular, sans-serif',
                          color: 'white',
                        }}
                      >
                        Ámbito Petrolero
                      </h3>
                    </div>
                  </div>
                </div>
              </div>


              {/* Servicios Generales */}
              <div className={isMobile ? 'Inf-Nuestras-solucionesMobile2' : 'Inf-Nuestras-solucionesDesktop2'}>

                {/* Lista de características a la izquierda */}
                <div style={{ flex: '1', paddingRight: '20px' }}>
                  <ul className={isMobile ? 'text-Nuestras-solucionesMobile' : 'text-Nuestras-solucionesDesktop'}>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Servicio de contratación de personal.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Operaciones logísticas nacionales e internacionales.
                    </li>
                    <li style={{ marginBottom: '0px', position: 'relative', paddingLeft: '20px' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#000000', fontWeight: 'bold' }}>•</span>
                      Industria petrolera: Servicios de cementación y estimulación.
                    </li>
                  </ul>
                </div>

                {/* Imagen con título en footer a la derecha */}
                <div style={{
                  flex: isMobile ? '1' : '0 0 350px',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  <div style={{ height: '450px', position: 'relative' }}>
                    <img
                      src="/assets/images/resources/Servicio-Generales.png"
                      alt="Servicios Generales"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                  <div style={{
                    padding: '20px',
                    textAlign: 'center',
                    backgroundColor: '#023352',
                    color: 'white'
                  }}>
                    <h3 style={{
                      fontSize: '20px',
                      fontWeight: '600',
                      margin: '0',
                      fontFamily: 'Axiforma-Regular, sans-serif',
                      color: 'white'
                    }}>
                      Soluciones Generales
                    </h3>
                  </div>
                </div>

              </div>
              {/* Servicios Generales */}

            </div>
          </div>
        </section>
        <section className="project-two" style={{ marginBottom: '0px', paddingTop: '60px', paddingBottom: '40px' }}>

          <div className="project-two__container">
            <div className="titulo-fondoNS1">
              <h2 className={isMobile ? 'section-title__titleNS2Mobile' : 'section-title__titleNS2Desktop'}>MAQUINARIAS Y EQUIPOS</h2>
            </div>

            <div className="row" style={{ display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap' }}>
              {/* Maquinaria Pesada */}
              <div className="col-lg-4 col-md-6" style={{ maxWidth: '450px' }}>
                <a
                  href="#newsletter-section"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById('newsletter-section');
                    if (element) {
                      element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                      });
                    }
                  }}
                >
                  <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}>
                    <div style={{ height: '450px', overflow: 'hidden' }}>
                      <img
                        src="/assets/images/resources/001. Maquinaria-Pesada.png"
                        alt="Maquinaria Pesada"
                        style={{
                          width: '100%',
                          height: '100%',
                        }}
                      />
                    </div>
                    <div style={{
                      padding: '25px',
                      textAlign: 'center',
                      backgroundColor: '#1e4a72',
                      color: 'white'
                    }}>
                      <h3 style={{
                        fontSize: '22px',
                        fontWeight: '600',
                        margin: '0',
                        fontFamily: 'Axiforma-Regular, sans-serif',
                        color: 'white'
                      }}>
                        Maquinaria Pesada
                      </h3>
                    </div>
                  </div>
                </a>
              </div>

              {/* Unidades Livianas */}
              <div className="col-lg-4 col-md-6" style={{ maxWidth: '450px' }}>
                <a
                  href="#newsletter-section"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById('newsletter-section');
                    if (element) {
                      element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                      });
                    }
                  }}
                >
                  <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}>
                    <div style={{ height: '450px', overflow: 'hidden' }}>
                      <img
                        src="/assets/images/resources/002. Unidades-Livianas.png"
                        alt="Servicios Generales"
                        style={{
                          width: '100%',
                          height: '100%',
                        }}
                      />
                    </div>
                    <div style={{
                      padding: '25px',
                      textAlign: 'center',
                      backgroundColor: '#1e4a72',
                      color: 'white'
                    }}>
                      <h3 style={{
                        fontSize: '22px',
                        fontWeight: '600',
                        margin: '0',
                        fontFamily: 'Axiforma-Regular, sans-serif',
                        color: 'white'
                      }}>
                        Unidades Livianas
                      </h3>
                    </div>
                  </div>
                </a>
              </div>

              {/* Equipos y Herramientas */}
              <div className="col-lg-4 col-md-6" style={{ maxWidth: '450px' }}>
                <a
                  href="#newsletter-section"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById('newsletter-section');
                    if (element) {
                      element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                      });
                    }
                  }}
                >
                  <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    cursor: 'pointer'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-10px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}>
                    <div style={{ height: '450px', overflow: 'hidden' }}>
                      <img
                        src="/assets/images/resources/003. Equipos-y-Herramientas.png"
                        alt="Ámbito Petrolero"
                        style={{
                          width: '100%',
                          height: '100%',
                        }}
                      />
                    </div>
                    <div style={{
                      padding: '25px',
                      textAlign: 'center',
                      backgroundColor: '#1e4a72',
                      color: 'white'
                    }}>
                      <h3 style={{
                        fontSize: '22px',
                        fontWeight: '600',
                        margin: '0',
                        fontFamily: 'Axiforma-Regular, sans-serif',
                        color: 'white'
                      }}>
                        Equipos y Herramientas
                      </h3>
                    </div>
                  </div>
                </a>
              </div>
            </div>


          </div>
        </section>
        <section className="work-detailsSoluciones3">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">

              </div>
            </div>





            {productos.map((item: any) => {
              let beneficios = item.beneficios ? item.beneficios.split('@') : [];
              let caracteristica = item.caracteristicas ? item.caracteristicas.split('@') : [];

              return (
                <>
                  <div className="work-detailsContacto__content">
                    <div className="row">

                      <div className="col-xl-12 col-lg-12">
                        <div className="work-detailsContacto__content-leftSol">

                          <h2 className="work-details__text-1"><span className="colorCalidad">{item.titulo}</span></h2>
                          <p className="work-details__textsolucion-4">{item.descripcion}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {beneficios.length > 0 && (<><div className="col-xl-12">
                    <div className="section-titleProductos ">
                      <h2 className="section-title__titleProducSol">Beneficios de nuestro servicio:
                      </h2>
                    </div>

                  </div>
                    <p className="section-title__titleProducSoluc">
                      {beneficios.map((caracteristica: any, index: any) => (
                        <li> {formatText(caracteristica)}</li>
                      ))}
                    </p></>
                  )}

                  {caracteristica.length > 0 && (<><div className="col-xl-12">
                    <div className="section-titleProductos ">
                      <h2 className="section-title__titleProducSol">Características del servicio:
                      </h2>
                    </div>

                  </div>
                    <p className="section-title__titleProducSoluc">
                      {caracteristica.map((caracteristica: any, index: any) => (
                        <li> {caracteristica}</li>
                      ))}
                    </p></>
                  )}
                  <div
                    className="tips2 slider2Soluciones"
                    style={{
                      backgroundImage: `url(${isMobile ? BASE_URL + item.fotomobile : BASE_URL + item.fotoweb})`
                    }}
                  />

                </>
              )
            }
            )}


          </div>
        </section>

        <NewsLetter />

        <Footer />
      </div>
    </>
  );
}

export default Solutions;
